import { render } from "./NapList.vue?vue&type=template&id=98616564&ts=true"
import script from "./NapList.vue?vue&type=script&lang=ts"
export * from "./NapList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__